import React, {FC} from 'react';
import styled from 'styled-components';
import {COLORS} from '../../../../constants/colors';
import {SPACING} from '../../../../constants/sizing';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../../constants/typography';
import {Flyout, Body as FlyoutBody} from '../../../atoms/Flyout/Flyout';
import {
  FilterFlyoutFooter,
  FilterFlyoutFooterProps,
} from './FilterFlyoutFooter';

export const PADDING_X = '1rem';

interface Props {
  className?: string;
  title: string | React.ReactNode;
  onClose: VoidFunction;
  open: boolean;
  footer?: typeof FilterFlyoutFooter;
  renderInPortal?: boolean;
}

export const FilterFlyout: FC<
  React.PropsWithChildren<Props & Partial<FilterFlyoutFooterProps>>
> = ({
  children,
  open,
  title,
  onClose,
  footer: FooterComponent,
  onPrimaryButtonClick,
  onSecondaryButtonClick,
  primaryButtonDataTestId,
  primaryButtonLabel,
  secondaryButtonDataTestId,
  secondaryButtonLabel,
  renderInPortal,
  className,
}) => {
  return (
    <StyledFlyout
      className={className}
      fullHeight
      headerContent={
        typeof title === 'string' ? (
          <HeaderTitle data-testid="filterFlyoutHeaderTitle">
            {title}
          </HeaderTitle>
        ) : (
          <>{title}</>
        )
      }
      onClose={onClose}
      open={open}
      renderInPortal={renderInPortal}
      bodyContent={
        FooterComponent ? (
          <>
            <Sections>{children}</Sections>
            <FooterComponent
              onPrimaryButtonClick={onPrimaryButtonClick}
              onSecondaryButtonClick={onSecondaryButtonClick}
              primaryButtonDataTestId={primaryButtonDataTestId}
              primaryButtonLabel={primaryButtonLabel || ''}
              secondaryButtonDataTestId={secondaryButtonDataTestId}
              secondaryButtonLabel={secondaryButtonLabel || ''}
              onClose={onClose}
            />
          </>
        ) : (
          <>{children}</>
        )
      }
    />
  );
};

const StyledFlyout = styled(Flyout)`
  ${FlyoutBody} {
    padding: 0;
  }
`;

const HeaderTitle = styled.h3`
  display: block;
  width: 100%;
  font-weight: ${FONT_WEIGHTS.bold};
  font-size: ${FONT_SIZES.px20};
  color: ${COLORS.Black};
  text-align: center;
  margin: 0;
  padding: 0 ${PADDING_X};
  text-align: center;
  box-sizing: border-box;
`;

export const Sections = styled.div`
  flex: 1;
  overflow-x: hidden;
  overflow-y: auto;
  padding: ${SPACING['Y.Lg']} ${SPACING['X.Lg']};
  margin-bottom: 4px;

  > * {
    background-color: ${COLORS.White};

    &:last-child {
      margin-bottom: 0;
    }
  }
`;
